import React, { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';

const PUBLISHER_ID = 'ca-pub-5935660145137949';
const IS_DEV = process.env.NODE_ENV !== 'production';

const GoogleAd = ({
    slot,
    style,
    format = 'auto',
    responsive = 'true',
    layout,
    className = '',
    label = 'Advertisement',
}) => {
    const insRef = useRef(null);
    const observerRef = useRef(null);
    const [status, setStatus] = useState('pending');
    const { pathname } = useLocation();

    useEffect(() => {
        const el = insRef.current;
        if (!el) return;

        if (el.dataset.adsbygoogleStatus) {
            const initial = el.getAttribute('data-ad-status');
            if (initial === 'filled') setStatus('filled');
            else if (initial === 'unfilled') setStatus('unfilled');
            return;
        }

        try {
            (window.adsbygoogle = window.adsbygoogle || []).push({});
        } catch (e) {
            if (IS_DEV) console.error('AdSense push error:', e);
        }

        const observer = new MutationObserver(() => {
            const adStatus = el.getAttribute('data-ad-status');
            if (adStatus === 'filled') {
                setStatus('filled');
                observer.disconnect();
            } else if (adStatus === 'unfilled') {
                setStatus('unfilled');
                observer.disconnect();
            }
        });
        observer.observe(el, { attributes: true, attributeFilter: ['data-ad-status'] });
        observerRef.current = observer;

        const timeout = setTimeout(() => {
            const adStatus = el.getAttribute('data-ad-status');
            if (adStatus === 'filled') setStatus('filled');
            else setStatus('unfilled');
            observer.disconnect();
        }, 4000);

        return () => {
            observer.disconnect();
            clearTimeout(timeout);
        };
    }, [pathname, slot]);

    const visible = status === 'filled';

    return (
        <div
            className={`ad-container ${className}${visible ? ' ad-filled' : ''}`}
            aria-hidden={!visible}
        >
            {visible && label && <span className="ad-slot-label">{label}</span>}
            <ins
                ref={insRef}
                key={`${pathname}-${slot}`}
                className="adsbygoogle"
                style={{ display: 'block', ...style }}
                data-ad-client={PUBLISHER_ID}
                data-ad-slot={slot}
                data-ad-format={format}
                data-ad-layout={layout}
                data-full-width-responsive={responsive}
                data-adtest={IS_DEV ? 'on' : undefined}
            />
        </div>
    );
};

export default GoogleAd;
